import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  Heading,
  Text,
  HealthStatus
} from 'components/common/Elements/Elements';

import { isObjNotEmpty } from 'utils/common';

import classes from './BaseItem.module.scss';

const BaseItem = ({ data: { name, value, additional, ...rest } }) => {
  const keys = isObjNotEmpty(rest) ? Object.keys(rest) : null;

  return (
    <div className={classes.content}>
      <Heading weight="m">{name}: </Heading>
      <Text className={classes.value} size={6} weight="m">
        {value}
      </Text>
      {additional && <HealthStatus status={additional} />}
      {keys &&
        keys.map(key => (
          <Fragment key={key}>
            <Text className={classes.key}>{`${key}: `}</Text>
            <Text className={classes.key_value} size={6} weight="m">
              {rest[key]}
            </Text>
          </Fragment>
        ))}
    </div>
  );
};

BaseItem.propTypes = {
  data: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    additional: PropTypes.string
  })
};

export default BaseItem;
